// extracted by mini-css-extract-plugin
module.exports = {"root":"root-n88zR","link":"link-1fO6x"};